import React from "react";
import Logo from "../components/Logo";

export function StaticPage({ title, subtitle, children }) {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid={`static-${title}`}>
      <div className="font-outfit font-black uppercase tracking-widest text-xs bodh-text-gradient">Bodh Networks</div>
      <h1 className="mt-2 font-devanagari font-black text-4xl sm:text-5xl text-zinc-900">{title}</h1>
      {subtitle && <p className="mt-2 font-hind text-zinc-500">{subtitle}</p>}
      <div className="mt-8 prose prose-zinc max-w-none font-devanagari leading-relaxed text-zinc-700 space-y-4">
        {children}
      </div>
    </div>
  );
}

export const About = () => (
  <StaticPage title="हमारे बारे में" subtitle="About Bodh Networks">
    <p>Bodh Networks एक स्वतंत्र, हिंदी-प्रथम डिजिटल न्यूज नेटवर्क है — जिसका उद्देश्य है दर्शकों तक केवल खबरें नहीं, बल्कि <b>बोध</b> पहुँचाना. हम राष्ट्रीय, अंतरराष्ट्रीय, राजनीति, बिजनेस, टेक्नोलॉजी, मनोरंजन, खेल, ज्योतिष और लाइफस्टाइल — हर क्षेत्र की प्रामाणिक रिपोर्टिंग करते हैं.</p>
    <p>हमारा मिशन है — आधुनिक भारत के लिए ऐसा डिजिटल मीडिया तैयार करना जो तेज, स्मार्ट, जिम्मेदार और भरोसेमंद हो.</p>
  </StaticPage>
);

export const Contact = () => (
  <StaticPage title="संपर्क" subtitle="हमसे जुडिए">
    <p>ईमेल: <a className="text-[#E30613]" href="mailto:contact@bodhnetworks.com">contact@bodhnetworks.com</a></p>
    <p>पता: बोध मीडिया हाउस, नई दिल्ली, भारत</p>
    <p>विज्ञापन के लिए: <a className="text-[#E30613]" href="mailto:ads@bodhnetworks.com">ads@bodhnetworks.com</a></p>
  </StaticPage>
);

export const Careers = () => (
  <StaticPage title="करियर" subtitle="Join the Bodh Team">
    <p>क्या आप पत्रकारिता को बदलना चाहते हैं? हमारी टीम का हिस्सा बनिए. हम संवाददाताओं, संपादकों, डिजाइनरों और टेक्नोलॉजिस्ट्स की तलाश में हैं.</p>
    <p>आवेदन भेजें: <a className="text-[#E30613]" href="mailto:admin@bodhnetworks.com">admin@bodhnetworks.com</a></p>
  </StaticPage>
);

export const Advertise = () => (
  <StaticPage title="हमारे साथ विज्ञापन करें" subtitle="Advertise with Bodh Networks">
    <p>देश के तेजी से बढते हिंदी डिजिटल न्यूज नेटवर्क पर अपना ब्रांड प्रचारित करें. डिस्प्ले, स्पॉन्सर्ड पॉडकास्ट, और ब्रांडेड कंटेंट के अवसर उपलब्ध हैं.</p>
  </StaticPage>
);

export const FactCheck = () => (
  <StaticPage title="फैक्ट चेक" subtitle="Bodh Fact Check Desk">
    <p>हमारी फैक्ट-चेक डेस्क सोशल मीडिया पर वायरल दावों की प्रामाणिकता की पुष्टि करती है. अगर आपको कोई संदिग्ध जानकारी मिले, तो हमें भेजें.</p>
  </StaticPage>
);

export const Privacy = () => (
  <StaticPage title="गोपनीयता नीति" subtitle="Privacy Policy">
    <p>Bodh Networks उपयोगकर्ता डेटा की गोपनीयता का सम्मान करता है. हम केवल वही जानकारी एकत्रित करते हैं जो हमारी सेवाओं के संचालन के लिए आवश्यक है.</p>
  </StaticPage>
);

export const Terms = () => (
  <StaticPage title="उपयोग की शर्तें" subtitle="Terms & Conditions">
    <p>इस वेबसाइट का उपयोग करके आप हमारी सेवा शर्तों से सहमत होते हैं. सामग्री का अनधिकृत पुनरुत्पादन वर्जित है.</p>
  </StaticPage>
);

export const Live = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="live-page">
    <div className="relative aspect-video rounded-3xl overflow-hidden bg-zinc-900">
      <img src="https://images.unsplash.com/photo-1495020689067-958852a7765e?crop=entropy&cs=srgb&fm=jpg&q=85" className="absolute inset-0 w-full h-full object-cover opacity-50" alt="" />
      <div className="absolute inset-0 bg-black/50" />
      <div className="absolute top-5 left-5 px-3 py-1 rounded-full bg-[#E30613] text-white text-xs font-outfit font-black uppercase tracking-widest flex items-center gap-2">
        <span className="h-2 w-2 rounded-full bg-white bodh-pulse" /> LIVE
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6">
        <h1 className="font-devanagari font-black text-4xl sm:text-5xl">Bodh Live जल्द आ रहा है</h1>
        <p className="mt-3 max-w-xl font-devanagari text-white/90">हमारा 24x7 हिंदी न्यूज लाइव स्ट्रीम जल्द ही उपलब्ध होगा. अपडेट के लिए न्यूजलेटर सब्सक्राइब करें.</p>
      </div>
    </div>
  </div>
);
